import { parseImmo } from '../util/immoObjectParser';
import { dummymakler1, dummymakler2, dummymakler3, dummymakler4 } from './demo_makler';

export const interessentimmo1 = {
  id: 14162233,
  tenant_id: 960,
  created_at: '2024-10-01T13:53:16+02:00',
  updated_at: '2025-03-25T11:46:36+01:00',
  published_at: '2024-10-01T14:23:16+02:00',
  catalogue_number: {
    plain: 69486,
    display: '960/69486',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: 'Knsuperweg',
    number: '442',
    entrance: null,
    door: null,
    zip: '2340',
    city: 'Mödling',
    floor: null,
    country: 'AT',
    geo_coordinates: {
      latitude: 48.0759541,
      longitude: 16.2789628,
      additionalProperties: {},
    },
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2340',
    city: 'Mödling',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.0759541,
      longitude: 16.2789628,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.07646273,
      longitude: 16.28094602,
      radius: 656,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 2,
    name: 'Wohnung',
    openimmo_key: 'wohnung',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: {
      area: 240,
    },
    living_area: {
      area: 123,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: {
      area: null,
      count: 1,
    },
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: null,
  },
  rooms: {
    rooms: null,
    toilets: null,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 780000,
      gross: 780000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '527eKBFKId8MYVIEYoRZZO.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value:
        '<h1>2340 Mödling, Liebevolles Einfamilienhaus</h1>\r\n\r\n<p>Gfl. ca. 240 m², Wfl. ca. 123 m², 2 Stockwerke, klimatisiert, Parkettboden, Bad mit WC, moderne Ausstattung, sehr gute Infrastruktur.</p>',
      locale: 'de',
    },
  ],
  agent: {
    id: 19442197,
    prefix: '',
    first_name: dummymakler1.firstName,
    last_name: dummymakler1.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler1.firstName.toLowerCase()}.${dummymakler1.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler1.profilePictureFileId,
      filename: 'dummymakler1.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 35471,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstraßer Hauptstraße 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 28531171,
        created_at: '2023-07-18T12:56:48+02:00',
        updated_at: '2025-03-25T10:51:22+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 35443405,
        created_at: '2024-10-01T13:53:16+02:00',
        updated_at: '2024-10-01T13:53:17+02:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 35443408,
        created_at: '2024-10-01T13:53:17+02:00',
        updated_at: '2024-10-01T13:53:17+02:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '4oxAX8Hvi8I4LscZlqLas8.png',
      url: 'https://storage.justimmo.at/file/4oxAX8Hvi8I4LscZlqLas8.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-03-06T16:08:12+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 233555,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/13b212f1ea95d28bfa2703323cea7254/fc_h300_w100/4oxAX8Hvi8I4LscZlqLas8.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/0bc36cc2e52f7117b409384f06e038b0/fc_h1080_w1920/4oxAX8Hvi8I4LscZlqLas8.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/d0aed2934feaf04d31a7979eded19ba8/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4oxAX8Hvi8I4LscZlqLas8.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '6seciXYe3ARKcJRwgjvcnN.jpg',
      url: 'https://storage.justimmo.at/file/6seciXYe3ARKcJRwgjvcnN.jpg',
      original_filename: 'grundriss_OG.jpg',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T14:53:23+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 12299,
      mime_type: 'image/jpeg',
      width: 1008,
      height: 630,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/b2c5d2397e5a9b74d344fc362a4be31d/fc_h300_w100/6seciXYe3ARKcJRwgjvcnN.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/95a15578136ab9d666bfcba1d7574c2d/fc_h1080_w1920/6seciXYe3ARKcJRwgjvcnN.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7af2595885e956d46f2c27a3ec76652d/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6seciXYe3ARKcJRwgjvcnN.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '4c7axDBPlEj1W2fqL0Rfr6.jpg',
      url: 'https://storage.justimmo.at/file/4c7axDBPlEj1W2fqL0Rfr6.jpg',
      original_filename: 'grundriss_EG.jpg',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T14:53:22+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 17968,
      mime_type: 'image/jpeg',
      width: 1008,
      height: 630,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/72c9db54b866fb685198f1cca5c42566/fc_h300_w100/4c7axDBPlEj1W2fqL0Rfr6.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/d38e0cb83ff6779360490497add861e0/fc_h1080_w1920/4c7axDBPlEj1W2fqL0Rfr6.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/b4d699eb2691b4f304397cac3e889da2/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4c7axDBPlEj1W2fqL0Rfr6.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '527eKBFKId8MYVIEYoRZZO.jpeg',
      url: 'https://storage.justimmo.at/file/527eKBFKId8MYVIEYoRZZO.jpeg',
      original_filename: 'Außenansicht.jpeg',
      title: 'Außenansicht',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T13:49:52+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 210395,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/6f3195c59cf60fe823f5b6e6086f50f1/fc_h300_w100/527eKBFKId8MYVIEYoRZZO.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/1a8b55b17976f335d076e988f9fd84e0/fc_h1080_w1920/527eKBFKId8MYVIEYoRZZO.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/57df0b265e3ba42204638086026f8582/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/527eKBFKId8MYVIEYoRZZO.jpeg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Charmantes Einfamilienhaus in Mödling',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Wohnen Sie im Herzen einer Stadt mit einer perfekten Mischung aus Natur, Kultur und urbanem Leben, die eine hohe Lebensqualität bietet.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '<p>Willkommen in Ihrem neuen Zuhause! Dieses moderne, zweistöckige Haus in Mödling bietet auf 123 m² Wohnfläche alles, was das Herz begehrt. Das Grundstück umfasst insgesamt 240 m² und bietet ausreichend Platz für Entspannung und Freizeit.</p>\r\n\r\n<p>Im Erdgeschoss erwartet Sie eine einladende Wohnküche mit stilvollen Fliesen und Parkettboden, die zum gemeinsamen Kochen und Verweilen einlädt. Ein praktisches Vorzimmer sowie ein Badezimmer mit WC runden das Raumangebot auf dieser Ebene ab.</p>\r\n\r\n<p>Über eine Treppe gelangen Sie in den großzügigen Dachboden, der als ein einziger, großer Raum gestaltet ist. Hier haben Sie vielfältige Nutzungsmöglichkeiten – ob als Schlafzimmer, Büro oder Hobbyraum, Ihrer Kreativität sind keine Grenzen gesetzt.</p>\r\n\r\n<p>Das Haus ist mit einer Klimaanlage ausgestattet, die an heißen Sommertagen für angenehme Temperaturen sorgt. Die moderne Ausstattung und die hochwertigen Materialien verleihen dem Haus eine zeitgemäße und gemütliche Atmosphäre.</p>\r\n\r\n<p>Dieses charmante Haus in Mödling ist der perfekte Ort, um sich wohlzufühlen und das Leben in vollen Zügen zu genießen. Überzeugen Sie sich selbst und vereinbaren Sie noch heute einen Besichtigungstermin!</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [
      {
        value:
          '<p>Willkommen in Ihrem neuen Zuhause! Dieses moderne, zweistöckige Haus in Mödling bietet auf 123 m² Wohnfläche alles, was das Herz begehrt. Das Grundstück umfasst insgesamt 240 m² und bietet ausreichend Platz für Entspannung und Freizeit.</p>\r\n\r\n<p>Im Erdgeschoss erwartet Sie eine einladende Wohnküche mit stilvollen Fliesen und Parkettboden, die zum gemeinsamen Kochen und Verweilen einlädt. Ein praktisches Vorzimmer sowie ein Badezimmer mit WC runden das Raumangebot auf dieser Ebene ab.</p>\r\n\r\n<p>Über eine Treppe gelangen Sie in den großzügigen Dachboden, der als ein einziger, großer Raum gestaltet ist. Hier haben Sie vielfältige Nutzungsmöglichkeiten – ob als Schlafzimmer, Büro oder Hobbyraum, Ihrer Kreativität sind keine Grenzen gesetzt.</p>\r\n\r\n<p>Das Haus ist mit einer Klimaanlage ausgestattet, die an heißen Sommertagen für angenehme Temperaturen sorgt. Die moderne Ausstattung und die hochwertigen Materialien verleihen dem Haus eine zeitgemäße und gemütliche Atmosphäre.</p>\r\n\r\n<p>Dieses charmante Haus in Mödling ist der perfekte Ort, um sich wohlzufühlen und das Leben in vollen Zügen zu genießen. Überzeugen Sie sich selbst und vereinbaren Sie noch heute einen Besichtigungstermin!</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1.7,
      class: 4,
      additionalProperties: {},
    },
    heating_demand: {
      value: 3.5,
      class: 3,
      additionalProperties: {},
    },
    valid_until: '2026-09-10T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 4,
          label: 'Fliesen',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fußbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Küche',
      items: [
        {
          id: 22,
          label: 'Einbauküche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fernsehen',
      items: [
        {
          id: 42,
          label: 'Kabel / Satelliten-TV',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Belüftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Elektrik',
      items: [
        {
          id: 150,
          label: 'IT-Verkabelung Cat 5',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 1048,
          label: 'E-Ladestation für KFZ',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 155,
          label: 'Innenliegender Sonnenschutz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Beleuchtung',
      items: [
        {
          id: 161,
          label: 'Deckenleuchten',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Dachform',
      items: [
        {
          id: 173,
          label: 'Satteldach',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 175,
          label: 'Fertigteil',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 655,
          label: 'Seeblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 930,
          label: 'Bad mit WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    259044556:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose\\u0022, \\u00222023_07_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 650.000,00\\u00A0\\u20AC","Created_at":"2024-09-25T14:51:13+02:00","Offertext":"\\u003Ch3\\u003EHier finden Sie Informationen inkl. umfangreichem Expos\\u00E9 zu Ihrem Immobilienangebot:\\u003C/h3\\u003E\\u003Cp\\u003EViele unserer Immobilien k\\u00F6nnen Sie online mittels \\u003Cstrong\\u003E360\\u00B0 Rundgang\\u003C/strong\\u003E besichtigen! Klicken Sie dazu einfach auf das entsprechende 360\\u00B0 Symbol unten im Bild.\\u003Cbr /\\u003E\\nAuch auf unserer Webseite www.sreal.at\\u00A0finden Sie viele Objekte mit Online-Rundgang!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/25182919/35316517/7d3f8c9e62fa015e7b48706cdd6d50f9d83b5886/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"76hEgISEPrcHPtJJq0li6X.pdf","Url":"https://api.justimmo.at/v1/file/76hEgISEPrcHPtJJq0li6X.pdf","Original_filename":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose.pdf","Title":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2024-09-25T14:51:15+02:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":8165723,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"3NTWwcryptUvPi3NB0ygqx.pdf","Url":"https://storage.justimmo.at/file/3NTWwcryptUvPi3NB0ygqx.pdf","Original_filename":"2023_07_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2023-07-06T12:49:10+02:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":96487,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
    ImmoLiveHighestBid: 0,
  },
};

export const interessentimmo1_parsed = parseImmo(interessentimmo1);

export const interessentimmo1_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 334,
          additionalProperties: {},
        },
        {
          id: 'subway',
          name: 'U-Bahn',
          distance: 6413,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 1660,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 3538,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 4119,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 448,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 794,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 729,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 2017,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 557,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 856,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 895,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 975,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 975,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 972,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 1320,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 928,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 1155,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 1719,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const interessentimmo2 = {
  id: 13889317,
  tenant_id: 960,
  created_at: '2024-09-11T15:30:33+02:00',
  updated_at: '2025-03-25T11:58:20+01:00',
  published_at: '2024-09-11T15:38:08+02:00',
  catalogue_number: {
    plain: 69434,
    display: '960/69434',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: 'Bahnhofsstraße',
    number: '220',
    entrance: null,
    door: null,
    zip: '2320',
    city: 'Mannswörth',
    floor: null,
    country: 'AT',
    geo_coordinates: {
      latitude: 48.1460787,
      longitude: 16.5138642,
      additionalProperties: {},
    },
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2320',
    city: 'Mannswörth',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.1460787,
      longitude: 16.5138642,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.14686577,
      longitude: 16.4969684,
      radius: 1688,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 2,
    name: 'Wohnung',
    openimmo_key: 'wohnung',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: 1960,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 79,
    },
    floor_area: {
      area: 86,
    },
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: null,
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: {
      area: null,
      count: 1,
    },
    parking_space_area: null,
  },
  rooms: {
    rooms: 3,
    toilets: 2,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 399000,
      gross: 399000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 143,
      gross: 143,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 189,
      gross: 189,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '33VBKZJtqBfKwwlgVxxWo7.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value:
        '<h1>2320 Mannswörth, 3 Zimmer Traum</h1>\r\n\r\n<p>Wfl. ca. 79 m², Balkon, 2 WCs, offene Wohnküche, Erstbezug, hochmoderne Ausstattung, sehr gute Infrastruktur, Supermärkte wenige Gehminuten entfernt.</p>',
      locale: 'de',
    },
  ],
  agent: {
    id: 19442197,
    prefix: '',
    first_name: dummymakler1.firstName,
    last_name: dummymakler1.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler1.firstName.toLowerCase()}.${dummymakler1.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler1.profilePictureFileId,
      filename: 'dummymakler1.jpg',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 35471,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstraßer Hauptstraße 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 28531171,
        created_at: '2023-07-18T12:56:48+02:00',
        updated_at: '2025-03-25T10:51:22+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 34937626,
        created_at: '2024-09-11T15:30:34+02:00',
        updated_at: '2025-02-05T18:17:12+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 34937632,
        created_at: '2024-09-11T15:30:34+02:00',
        updated_at: '2025-01-15T11:43:25+01:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '1v1ghEB13lCq79RANz8WiX.jpeg',
      url: 'https://storage.justimmo.at/file/1v1ghEB13lCq79RANz8WiX.jpeg',
      original_filename: 'Außenansicht 3.jpeg',
      title: 'Außenansicht 3',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-06T14:40:13+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 221093,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/8289a93ecb5d4d72eccb3dfa84df2e32/fc_h300_w100/1v1ghEB13lCq79RANz8WiX.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/a2992d249ab50a2bdc1ed125babb67d1/fc_h1080_w1920/1v1ghEB13lCq79RANz8WiX.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/a111f74331c62dc31baf6a92829e0baa/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1v1ghEB13lCq79RANz8WiX.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '6pPsCMvuEvGGC7t14v8hQO.jpeg',
      url: 'https://storage.justimmo.at/file/6pPsCMvuEvGGC7t14v8hQO.jpeg',
      original_filename: 'Außenansicht 2.jpeg',
      title: 'Außenansicht 2',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-03-06T14:39:04+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 187402,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/15813cab0e6cc6679c3b5da8406dbb85/fc_h300_w100/6pPsCMvuEvGGC7t14v8hQO.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/8847b7627f4eadec2a8ed765d5063b53/fc_h1080_w1920/6pPsCMvuEvGGC7t14v8hQO.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7a95dc276f1c23ca267522d23275463f/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6pPsCMvuEvGGC7t14v8hQO.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '4GakV2B0udFr7AVyYgFLl8.jpg',
      url: 'https://storage.justimmo.at/file/4GakV2B0udFr7AVyYgFLl8.jpg',
      original_filename: 'grundriss.jpg',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T14:26:22+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 19364,
      mime_type: 'image/jpeg',
      width: 1008,
      height: 630,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/79f161849b13a50f7e5bb1a44d605149/fc_h300_w100/4GakV2B0udFr7AVyYgFLl8.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/38e53978ae0892a6da5f6a56cf52b2cd/fc_h1080_w1920/4GakV2B0udFr7AVyYgFLl8.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/f313ea9560e9d484d70ff9917142a94f/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4GakV2B0udFr7AVyYgFLl8.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: 'euGp3Fo7cJaGcVqfCHT81.png',
      url: 'https://storage.justimmo.at/file/euGp3Fo7cJaGcVqfCHT81.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-03-06T14:14:18+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 367914,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/977215a426538af1f29c03a9e1f1c98d/fc_h300_w100/euGp3Fo7cJaGcVqfCHT81.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/30d03ce5b5384c7d2577342dfb590994/fc_h1080_w1920/euGp3Fo7cJaGcVqfCHT81.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/1134f9abef29c3bce3a978c1d0d40ba8/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/euGp3Fo7cJaGcVqfCHT81.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '33VBKZJtqBfKwwlgVxxWo7.jpeg',
      url: 'https://storage.justimmo.at/file/33VBKZJtqBfKwwlgVxxWo7.jpeg',
      original_filename: 'Außenansicht.jpeg',
      title: 'Außenansicht',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-06T13:51:33+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 204399,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/aa0fe033b706c5b5b307b0d516a08f87/fc_h300_w100/33VBKZJtqBfKwwlgVxxWo7.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/7001f89f02a9add789ab1b8e743ea523/fc_h1080_w1920/33VBKZJtqBfKwwlgVxxWo7.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/12c109369697361458cf617301837c10/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/33VBKZJtqBfKwwlgVxxWo7.jpeg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Moderne 3-Zimmer-Wohnung in Mannswörth mit Garage',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Zentrale Lage mit hervorragender Anbindung an die Stadt und den Flughafen Wien-Schwechat.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '<p>Entdecken Sie diese charmante 3-Zimmer-Wohnung im Herzen von Mannswörth! Mit einer Wohnfläche von 79 m² bietet diese Wohnung ausreichend Platz für Paare oder kleine Familien. Die Wohnung besticht durch ihre moderne Ausstattung, darunter hochwertiger Parkettboden und zwei separate WCs. Ein Garagenplatz ist ebenfalls im Preis von 399.000 Euro enthalten. Genießen Sie die ruhige Lage und die gute Anbindung an die Stadt.</p>\r\n\r\n<p>Mannswörth bietet eine hervorragende Infrastruktur, die das tägliche Leben angenehm und bequem macht. In unmittelbarer Nähe finden Sie zahlreiche Geschäfte des täglichen Bedarfs, darunter Supermärkte, Apotheken und Banken. Für Familien mit Kindern gibt es in der Umgebung Kindergärten und Schulen. Die Verkehrsanbindung ist ebenfalls ausgezeichnet: Mit dem Auto erreichen Sie schnell die nahegelegene Stadt Schwechat und den Flughafen Wien-Schwechat. Öffentliche Verkehrsmittel wie Busse und Bahnen sorgen für eine bequeme Anbindung an das Wiener Stadtzentrum.</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [
      {
        value:
          '<p>Entdecken Sie diese charmante 3-Zimmer-Wohnung im Herzen von Mannswörth! Mit einer Wohnfläche von 79 m² bietet diese Wohnung ausreichend Platz für Paare oder kleine Familien. Die Wohnung besticht durch ihre moderne Ausstattung, darunter hochwertiger Parkettboden und zwei separate WCs. Ein Garagenplatz ist ebenfalls im Preis von 399.000 Euro enthalten. Genießen Sie die ruhige Lage und die gute Anbindung an die Stadt.</p>\r\n\r\n<p>Mannswörth bietet eine hervorragende Infrastruktur, die das tägliche Leben angenehm und bequem macht. In unmittelbarer Nähe finden Sie zahlreiche Geschäfte des täglichen Bedarfs, darunter Supermärkte, Apotheken und Banken. Für Familien mit Kindern gibt es in der Umgebung Kindergärten und Schulen. Die Verkehrsanbindung ist ebenfalls ausgezeichnet: Mit dem Auto erreichen Sie schnell die nahegelegene Stadt Schwechat und den Flughafen Wien-Schwechat. Öffentliche Verkehrsmittel wie Busse und Bahnen sorgen für eine bequeme Anbindung an das Wiener Stadtzentrum.</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1.5,
      class: 4,
      additionalProperties: {},
    },
    heating_demand: {
      value: 2,
      class: 4,
      additionalProperties: {},
    },
    valid_until: '2026-12-19T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 12,
          label: 'Erdwärme',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fußbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Küche',
      items: [
        {
          id: 23,
          label: 'Wohnküche / offene Küche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Balkon',
      items: [
        {
          id: 27,
          label: 'Ostbalkon / -terrasse',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fernsehen',
      items: [
        {
          id: 42,
          label: 'Kabel / Satelliten-TV',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 44,
          label: 'Garage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Belüftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'WCs',
      items: [
        {
          id: 108,
          label: 'Pissoir',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 162,
          label: 'Toilette',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 167,
          label: 'Gäste-WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Extras',
      items: [
        {
          id: 113,
          label: 'Abstellraum',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Räume',
      items: [
        {
          id: 115,
          label: 'Räume veränderbar',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Energietyp',
      items: [
        {
          id: 130,
          label: 'Neubaustandard',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Elektrik',
      items: [
        {
          id: 153,
          label: 'Glasfaseranbindung',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 1054,
          label: 'Smart Home System',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 154,
          label: 'Außenliegender Sonnenschutz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Beleuchtung',
      items: [
        {
          id: 161,
          label: 'Deckenleuchten',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Dachform',
      items: [
        {
          id: 168,
          label: 'Flachdach',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausbaustufe',
      items: [
        {
          id: 181,
          label: 'Schlüsselfertig mit Keller',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 667,
          label: 'Fernblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 930,
          label: 'Bad mit WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 942,
          label: 'Stahlbeton',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    259044556:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose\\u0022, \\u00222023_07_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 650.000,00\\u00A0\\u20AC","Created_at":"2024-09-25T14:51:13+02:00","Offertext":"\\u003Ch3\\u003EHier finden Sie Informationen inkl. umfangreichem Expos\\u00E9 zu Ihrem Immobilienangebot:\\u003C/h3\\u003E\\u003Cp\\u003EViele unserer Immobilien k\\u00F6nnen Sie online mittels \\u003Cstrong\\u003E360\\u00B0 Rundgang\\u003C/strong\\u003E besichtigen! Klicken Sie dazu einfach auf das entsprechende 360\\u00B0 Symbol unten im Bild.\\u003Cbr /\\u003E\\nAuch auf unserer Webseite www.sreal.at\\u00A0finden Sie viele Objekte mit Online-Rundgang!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/25182919/35316517/7d3f8c9e62fa015e7b48706cdd6d50f9d83b5886/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"76hEgISEPrcHPtJJq0li6X.pdf","Url":"https://api.justimmo.at/v1/file/76hEgISEPrcHPtJJq0li6X.pdf","Original_filename":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose.pdf","Title":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2024-09-25T14:51:15+02:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":8165723,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"3NTWwcryptUvPi3NB0ygqx.pdf","Url":"https://storage.justimmo.at/file/3NTWwcryptUvPi3NB0ygqx.pdf","Original_filename":"2023_07_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2023-07-06T12:49:10+02:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":96487,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    259044799:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 25.09.2024, bis: 06.11.2025","Created_at":"2024-09-25T14:53:45+02:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    270933994:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose\\u0022, \\u00222023_07_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 650.000,00\\u00A0\\u20AC","Created_at":"2024-12-03T14:57:44+01:00","Offertext":"\\u003Ch3\\u003EHier finden Sie Informationen inkl. umfangreichem Expos\\u00E9 zu Ihrem Immobilienangebot:\\u003C/h3\\u003E\\u003Cp\\u003EViele unserer Immobilien k\\u00F6nnen Sie online mittels \\u003Cstrong\\u003E360\\u00B0 Rundgang\\u003C/strong\\u003E besichtigen! Klicken Sie dazu einfach auf das entsprechende 360\\u00B0 Symbol unten im Bild.\\u003Cbr /\\u003E\\nAuch auf unserer Webseite www.sreal.at\\u00A0finden Sie viele Objekte mit Online-Rundgang!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/26073472/36354988/e71287005e8093be6ef9979fa4a07c59008ad371/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"4WoCY9F0nmzk0ZM43QgFZE.pdf","Url":"https://api.justimmo.at/v1/file/4WoCY9F0nmzk0ZM43QgFZE.pdf","Original_filename":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose.pdf","Title":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2024-12-03T14:57:45+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":8165600,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"3NTWwcryptUvPi3NB0ygqx.pdf","Url":"https://storage.justimmo.at/file/3NTWwcryptUvPi3NB0ygqx.pdf","Original_filename":"2023_07_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2023-07-06T12:49:10+02:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":96487,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    271048369:
      '{"ActivityTypeId":27,"ActivityTypeName":"Schriftverkehr","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose\\u0022, \\u00222023_07_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 650.000,00\\u00A0\\u20AC","Created_at":"2024-12-04T13:29:38+01:00","Offertext":"\\u003Ch3\\u003ETestiTest\\u003C/h3\\u003E\\u003Ch3\\u003E\\u00A0\\u003C/h3\\u003E\\u003Ch3\\u003EHier finden Sie Informationen inkl. umfangreichem Expos\\u00E9 zu Ihrem Immobilienangebot:\\u003C/h3\\u003E\\u003Cp\\u003EViele unserer Immobilien k\\u00F6nnen Sie online mittels \\u003Cstrong\\u003E360\\u00B0 Rundgang\\u003C/strong\\u003E besichtigen! Klicken Sie dazu einfach auf das entsprechende 360\\u00B0 Symbol unten im Bild.\\u003Cbr /\\u003E\\nAuch auf unserer Webseite www.sreal.at\\u00A0finden Sie viele Objekte mit Online-Rundgang!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/26086972/26799867/0161233d72da26d97ea8ff93cf73170db844c977/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"6N5xwKNhKzEnnujhwNWECu.pdf","Url":"https://api.justimmo.at/v1/file/6N5xwKNhKzEnnujhwNWECu.pdf","Original_filename":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose.pdf","Title":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2024-12-04T13:29:39+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":8165602,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"3NTWwcryptUvPi3NB0ygqx.pdf","Url":"https://storage.justimmo.at/file/3NTWwcryptUvPi3NB0ygqx.pdf","Original_filename":"2023_07_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2023-07-06T12:49:10+02:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":96487,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    271246219:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 05.12.2024, bis: 12.12.2024","Created_at":"2024-12-05T15:37:24+01:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    271247017:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 05.12.2024, bis: 12.12.2024","Created_at":"2024-12-05T15:40:26+01:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    271254568:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 05.12.2024, bis: 12.12.2024","Created_at":"2024-12-05T16:08:12+01:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    271254856:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 05.12.2024, bis: 12.12.2024","Created_at":"2024-12-05T16:09:30+01:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    275507893:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 05.12.2024, bis: 30.06.2025","Created_at":"2025-01-15T11:43:25+01:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
    ImmoLiveHighestBid: 0,
  },
};

export const interessentimmo2_parsed = parseImmo(interessentimmo2);

export const interessentimmo2_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 210,
          additionalProperties: {},
        },
        {
          id: 'subway',
          name: 'U-Bahn',
          distance: 7238,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 3562,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 1162,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1513,
          additionalProperties: {},
        },
        {
          id: 'aerodrome',
          name: 'Flughafen',
          distance: 5712,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 325,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 2804,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 2919,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 257,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 159,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 6900,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 8547,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 2648,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 2797,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 276,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 2971,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 2968,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 2798,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 2968,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 4382,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const interessentimmo3 = {
  id: 13630336,
  tenant_id: 960,
  created_at: '2024-06-04T15:24:03+02:00',
  updated_at: '2025-03-25T12:01:05+01:00',
  published_at: '2024-06-04T15:28:38+02:00',
  catalogue_number: {
    plain: 68964,
    display: '960/68964',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: 'Bahnhofsstraße',
    number: '101',
    entrance: null,
    door: null,
    zip: '2522',
    city: 'Oberwaltersdorf',
    floor: null,
    country: 'AT',
    geo_coordinates: {
      latitude: 47.9762429,
      longitude: 16.3348546,
      additionalProperties: {},
    },
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2522',
    city: 'Oberwaltersdorf',
    country: 'AT',
    geo_coordinates: {
      latitude: 47.9762429,
      longitude: 16.3348546,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 47.96981995,
      longitude: 16.3348546,
      radius: 1427,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 3,
    name: 'Haus',
    openimmo_key: 'haus',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: 2006,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: {
      area: 750,
    },
    living_area: {
      area: 120,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: {
      area: 630,
      count: 1,
    },
    basement_area: {
      area: 80,
      count: 1,
    },
    balcony_area: null,
    terrace_area: {
      area: null,
      count: 2,
    },
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: {
      area: null,
      count: 3,
    },
  },
  rooms: {
    rooms: 4.5,
    toilets: 2,
    bathrooms: 2,
    storerooms: 1,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 775000,
      gross: 775000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 450,
      gross: 450,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 150,
      gross: 150,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '2VVdIy4LQ4l4Hr5XRAaR1z.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value:
        '<h1>2522 Oberwaltersdorf, Amerikanisches Traumhaus</h1>\r\n\r\n<p>Gfl. ca. 750 m², Wfl ca. 120 m², Garten ca. 630 m², Grillstelle, Sauna, Klimaanlage, Fußbodenheizung, Luftwärmepumpe, 3 Stellplätze</p>',
      locale: 'de',
    },
  ],
  agent: {
    id: 26053533,
    prefix: '',
    first_name: dummymakler2.firstName,
    last_name: dummymakler2.lastName,
    gender: 0,
    suffix: '',
    email: `${dummymakler2.firstName.toLowerCase()}.${dummymakler2.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 88304439',
    phone_business: '+43 (0)5 0100 - 26492',
    phone_mobile: '+43 664 88304439',
    profile_picture: {
      storage_key: dummymakler2.profilePictureFileId,
      filename: 'dummymakler2.jpg',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 38820,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstraßer Hauptstraße 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 28531171,
        created_at: '2023-07-18T12:56:48+02:00',
        updated_at: '2025-03-25T10:51:22+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 33358645,
        created_at: '2024-06-04T15:24:03+02:00',
        updated_at: '2025-03-18T14:23:22+01:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '5yBmJujL5O85p7EinRrVeD.png',
      url: 'https://storage.justimmo.at/file/5yBmJujL5O85p7EinRrVeD.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-03-06T14:38:41+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 237841,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/4590c49a1665e5f80bd1f099bc61db5a/fc_h300_w100/5yBmJujL5O85p7EinRrVeD.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/86aac890fa8cdfaa204089c937a304b2/fc_h1080_w1920/5yBmJujL5O85p7EinRrVeD.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/5821cb7b462bac379212702c914000bc/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5yBmJujL5O85p7EinRrVeD.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5tljYMkgwMm2dclLW9w0Qa.jpeg',
      url: 'https://storage.justimmo.at/file/5tljYMkgwMm2dclLW9w0Qa.jpeg',
      original_filename: 'Plan.jpeg',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T14:25:20+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 323686,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/1d3b510eb81a1c649bcab19542d745b0/fc_h300_w100/5tljYMkgwMm2dclLW9w0Qa.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/887804dfc80eba0de6ffa9b74d904487/fc_h1080_w1920/5tljYMkgwMm2dclLW9w0Qa.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7cf030503eb09a379ad266c78c8a8a89/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5tljYMkgwMm2dclLW9w0Qa.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2VVdIy4LQ4l4Hr5XRAaR1z.jpeg',
      url: 'https://storage.justimmo.at/file/2VVdIy4LQ4l4Hr5XRAaR1z.jpeg',
      original_filename: 'Landhaus.jpeg',
      title: '',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-06T13:50:19+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 204960,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/1db0d27f5417176c2a9656d07345c1bb/fc_h300_w100/2VVdIy4LQ4l4Hr5XRAaR1z.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/f4a9823eef12b7c1899c88cffc97cc7f/fc_h1080_w1920/2VVdIy4LQ4l4Hr5XRAaR1z.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c147c5ecb194456e8752f7861bcc4375/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2VVdIy4LQ4l4Hr5XRAaR1z.jpeg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Amerikanisches Traumhaus in Oberwaltersdorf - Ihr neues Zuhause!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [],
    description: [
      {
        value:
          '<p>Willkommen in Ihrem neuen Zuhause in 2522 Oberwaltersdorf, einem charmanten Ort in Niederösterreich, der Ihnen nicht nur eine wunderschöne Immobilie, sondern auch eine hohe Lebensqualität bietet.</p>\r\n\r\n<p>Dieses beeindruckende Einfamilienhaus überzeugt mit einer großzügigen Wohnfläche von 120 m², die sich perfekt für Familien oder Paare eignet, die viel Platz und Komfort schätzen. Mit insgesamt 4 Zimmern sind die Möglichkeiten zur individuellen Gestaltung nahezu unbegrenzt. Ob ein einladendes Wohnzimmer, ein Arbeitszimmer oder ein Spielzimmer für die Kinder – hier finden Sie die ideale Raumaufteilung für Ihre Bedürfnisse.</p>\r\n\r\n<p>Der Außenbereich dieser Immobilie ist ein wahres Highlight. Genießen Sie die warmen Sonnenstrahlen auf einer der zwei Terrassen oder entspannen Sie im liebevoll angelegten Garten, der Ihnen einen herrlichen Grünblick bietet. Hier können Sie die Natur in vollen Zügen genießen und die Abende mit Freunden und Familie ausklingen lassen.</p>\r\n\r\n<p>Die Ausstattung des Hauses lässt keine Wünsche offen. Hochwertige Parkett- und Steinböden sorgen für ein modernes Ambiente und die Fußbodenheizung garantiert Ihnen auch an kalten Tagen wohlige Wärme. Die offene Wohnküche ist der perfekte Ort, um kulinarische Köstlichkeiten zu zaubern und gemeinsam zu essen. Die beiden Bäder – eines mit Fenster, Badewanne und das andere mit Dusche – sind ideal für den stressfreien Alltag der ganzen Familie.</p>\r\n\r\n<p>Zusätzlich sind zwei WCs vorhanden, was den Komfort für Ihre Familie und Gäste erhöht.</p>\r\n\r\n<p>Die Verkehrsanbindung ist optimal: Mit dem Bus und dem nahegelegenen Bahnhof sind Sie schnell und unkompliziert in der Umgebung unterwegs. Für Ihre täglichen Besorgungen finden Sie in der unmittelbaren Nähe einen Arzt, eine Apotheke und eine Bäckerei, die Ihnen frische Brötchen für ein gemütliches Frühstück bieten.</p>\r\n\r\n<p>Mit einem Kaufpreis von 550.000,00 € bietet dieses Haus nicht nur ein Zuhause, sondern auch eine wertbeständige Investition in Ihre Zukunft. Lassen Sie sich dieses einmalige Angebot nicht entgehen und vereinbaren Sie noch heute einen Besichtigungstermin. Hier in Oberwaltersdorf wartet Ihr Traumhaus auf Sie!</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1.41,
      class: 2,
      additionalProperties: {},
    },
    heating_demand: {
      value: 2.3,
      class: 3,
      additionalProperties: {},
    },
    valid_until: '2025-01-01T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 8,
          label: 'Steinboden',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 116,
          label: 'Granit',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 17,
          label: 'Fernwärme',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 18,
          label: 'Fußbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Küche',
      items: [
        {
          id: 23,
          label: 'Wohnküche / offene Küche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 33,
          label: 'Bad mit Fenster',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 34,
          label: 'Badewanne',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 35,
          label: 'Dusche',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 930,
          label: 'Bad mit WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 44,
          label: 'Garage',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 46,
          label: 'Parkplatz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Extras',
      items: [
        {
          id: 56,
          label: 'Sauna',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 165,
          label: 'Bibliothek',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 679,
          label: 'Grillstelle',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 688,
          label: 'Weinkeller',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Belüftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 93,
          label: 'Luftwärmepumpe',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Balkon',
      items: [
        {
          id: 106,
          label: 'Südwestbalkon / -terrasse',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'WCs',
      items: [
        {
          id: 162,
          label: 'Toilette',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 167,
          label: 'Gäste-WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Dachform',
      items: [
        {
          id: 173,
          label: 'Satteldach',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 670,
          label: 'Doppel- / Mehrfachverglasung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 969,
          label: 'Grünblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    259044556:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose\\u0022, \\u00222023_07_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 650.000,00\\u00A0\\u20AC","Created_at":"2024-09-25T14:51:13+02:00","Offertext":"\\u003Ch3\\u003EHier finden Sie Informationen inkl. umfangreichem Expos\\u00E9 zu Ihrem Immobilienangebot:\\u003C/h3\\u003E\\u003Cp\\u003EViele unserer Immobilien k\\u00F6nnen Sie online mittels \\u003Cstrong\\u003E360\\u00B0 Rundgang\\u003C/strong\\u003E besichtigen! Klicken Sie dazu einfach auf das entsprechende 360\\u00B0 Symbol unten im Bild.\\u003Cbr /\\u003E\\nAuch auf unserer Webseite www.sreal.at\\u00A0finden Sie viele Objekte mit Online-Rundgang!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/25182919/35316517/7d3f8c9e62fa015e7b48706cdd6d50f9d83b5886/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"76hEgISEPrcHPtJJq0li6X.pdf","Url":"https://api.justimmo.at/v1/file/76hEgISEPrcHPtJJq0li6X.pdf","Original_filename":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose.pdf","Title":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2024-09-25T14:51:15+02:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":8165723,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"3NTWwcryptUvPi3NB0ygqx.pdf","Url":"https://storage.justimmo.at/file/3NTWwcryptUvPi3NB0ygqx.pdf","Original_filename":"2023_07_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2023-07-06T12:49:10+02:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":96487,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: 'none',
    dual_brokerage: false,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: {
      id: [],
      name: [],
    },
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
    ImmoLiveHighestBid: 0,
  },
};

export const interessentimmo3_parsed = parseImmo(interessentimmo3);

export const interessentimmo3_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 654,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 500,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 2615,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 6288,
          additionalProperties: {},
        },
        {
          id: 'aerodrome',
          name: 'Flughafen',
          distance: 5976,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 883,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 913,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 4624,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 6519,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 1063,
          additionalProperties: {},
        },
        {
          id: 'school',
          name: 'Schule',
          distance: 1135,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 932,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 932,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 2281,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 2260,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 1048,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 941,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 5796,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const interessentimmo4 = {
  id: 13601455,
  tenant_id: 960,
  created_at: '2024-05-16T16:26:18+02:00',
  updated_at: '2025-03-25T12:03:17+01:00',
  published_at: '2024-05-16T16:29:29+02:00',
  catalogue_number: {
    plain: 68798,
    display: '960/68798',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: 'Bahnhofsstraße',
    number: '102',
    entrance: null,
    door: null,
    zip: '2500',
    city: 'Alland',
    floor: null,
    country: 'AT',
    geo_coordinates: {
      latitude: 48.0565685,
      longitude: 16.0781371,
      additionalProperties: {},
    },
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2500',
    city: 'Alland',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.0565685,
      longitude: 16.0781371,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.05563732,
      longitude: 16.07973969,
      radius: 2688,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 3,
    name: 'Haus',
    openimmo_key: 'haus',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: 2016,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: {
      area: 850,
    },
    living_area: {
      area: 140,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: {
      area: 600,
      count: 1,
    },
    basement_area: {
      area: 100,
      count: 1,
    },
    balcony_area: null,
    terrace_area: {
      area: null,
      count: 1,
    },
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: {
      area: null,
      count: 3,
    },
  },
  rooms: {
    rooms: 4.5,
    toilets: 3,
    bathrooms: 2,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 975000,
      gross: 975000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 600,
      gross: 600,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 200,
      gross: 200,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '7lRsBMW1XsWcIa9TzeZqea.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value: '<h1>2500 Alland, Traumhaus</h1>\r\n\r\n<p>Gfl. ca. 850 m², Wfl ca. 140 m², Garten ca. 600 m², Grillstelle, Sauna, Klimaanlage, Fußbodenheizung, Luftwärmepumpe, 3 Stellplätze</p>',
      locale: 'de',
    },
  ],
  agent: {
    id: 26053533,
    prefix: '',
    first_name: dummymakler2.firstName,
    last_name: dummymakler2.lastName,
    gender: 0,
    suffix: '',
    email: `${dummymakler2.firstName.toLowerCase()}.${dummymakler2.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 88304439',
    phone_business: '+43 (0)5 0100 - 26492',
    phone_mobile: '+43 664 88304439',
    profile_picture: {
      storage_key: dummymakler2.profilePictureFileId,
      filename: 'dummymakler2.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 38820,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstraßer Hauptstraße 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 26649771,
        created_at: '2023-03-22T10:35:02+01:00',
        updated_at: '2025-01-16T14:47:46+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 28531171,
        created_at: '2023-07-18T12:56:48+02:00',
        updated_at: '2025-03-25T10:51:22+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 33107941,
        created_at: '2024-05-16T16:26:18+02:00',
        updated_at: '2025-03-12T14:27:06+01:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '7aMpEmDPBFIxFecjSSl04d.png',
      url: 'https://storage.justimmo.at/file/7aMpEmDPBFIxFecjSSl04d.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-03-06T15:56:42+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 376755,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/fc01e5f860bad1c389ce74c486b4953a/fc_h300_w100/7aMpEmDPBFIxFecjSSl04d.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/dcbe487c8a850aeb5cce396cbb8f8276/fc_h1080_w1920/7aMpEmDPBFIxFecjSSl04d.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/61fee55842c385e36ed52bf02b947c63/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7aMpEmDPBFIxFecjSSl04d.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '4ihZL5Xvaq0RrDUgpbiOPg.jpeg',
      url: 'https://storage.justimmo.at/file/4ihZL5Xvaq0RrDUgpbiOPg.jpeg',
      original_filename: 'Plan.jpeg',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T15:19:52+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 323686,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/d904397d34b2aabb6e4f41a947bfc953/fc_h300_w100/4ihZL5Xvaq0RrDUgpbiOPg.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/6cfc918c56150abcdc7c66e22263a43b/fc_h1080_w1920/4ihZL5Xvaq0RrDUgpbiOPg.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/ea3fdb402b9937ae11206b3c85d9a8f9/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4ihZL5Xvaq0RrDUgpbiOPg.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7lRsBMW1XsWcIa9TzeZqea.jpeg',
      url: 'https://storage.justimmo.at/file/7lRsBMW1XsWcIa9TzeZqea.jpeg',
      original_filename: 'Villa.jpeg',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-06T15:08:27+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 168284,
      mime_type: 'image/jpeg',
      width: 1024,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/4aa0e02d55ddfd61dc2f2dffb29cad3d/fc_h300_w100/7lRsBMW1XsWcIa9TzeZqea.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/9700ba9621bf51ece71417f3979d0dea/fc_h1080_w1920/7lRsBMW1XsWcIa9TzeZqea.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/317bf6ce753ba5582a3482ecdbe24d10/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7lRsBMW1XsWcIa9TzeZqea.jpeg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Traumhaus in Alland - Ihr neues Zuhause!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [],
    description: [
      {
        value:
          '<p>Willkommen in Ihrem neuen Zuhause in Alland, einer charmanten Gemeinde in Niederösterreich, die Ihnen nicht nur eine hervorragende Lebensqualität, sondern auch eine perfekte Kombination aus ländlichem Flair und städtischer Anbindung bietet.</p>\r\n\r\n<p>Dieses eindrucksvolle Einfamilienhaus mit einer großzügigen Wohnfläche von 140 m² steht zum Verkauf und bietet Ihnen alles, was Sie für ein komfortables und modernes Leben benötigen. Mit einem Kaufpreis von 975.000,00 € wird Ihnen hier ein einzigartiges Zuhause geboten, das keine Wünsche offenlässt.</p>\r\n\r\n<p>Das Haus verfügt über vier lichtdurchflutete Zimmer, die Ihnen und Ihrer Familie ausreichend Platz zur Entfaltung bieten. Die offene Wohnküche lädt zum gemeinsamen Kochen und Verweilen ein und schafft eine einladende Atmosphäre, die sowohl für entspannte Abende als auch für gesellige Zusammenkünfte perfekt geeignet ist. Die hochwertigen Materialien, wie Parkettböden und stilvolle Steinfliesen, unterstreichen den modernen Charakter der Immobilie.</p>\r\n\r\n<p>Ein besonderes Highlight sind die zwei eleganten Badezimmer, die mit Fenster, Badewanne und Dusche ausgestattet sind. Hier können Sie nach einem langen Tag wunderbar entspannen und neue Energie tanken. Zudem stehen Ihnen drei WCs zur Verfügung, was besonders in einem Familienhaushalt von großem Vorteil ist.</p>\r\n\r\n<p>Genießen Sie den Blick ins Grüne von Ihrer Terrasse oder aus dem Garten, der Ihnen nicht nur Platz für Ihre persönlichen Gartenideen bietet, sondern auch Raum für Entspannung und gesellige Stunden im Freien. Die drei Stellplätze erleichtern Ihnen zudem die Ankunft und Abfahrt, ohne das lästige Parkplatzsuchen in Kauf nehmen zu müssen.</p>\r\n\r\n<p>Die Anbindung an den öffentlichen Verkehr ist ausgezeichnet. In unmittelbarer Nähe finden Sie Busverbindungen sowie einen Autobahnanschluss, der Ihnen die Mobilität erleichtert und Ihnen den Weg in die nahegelegene Landeshauptstadt oder ins Umland ebnet.</p>\r\n\r\n<p>Die Lage des Hauses ist ideal für Familien. In der Umgebung finden Sie alles, was Sie für den täglichen Bedarf benötigen: Ärzte, Apotheken, Schulen und Kindergärten sind bequem zu Fuß oder mit dem Fahrrad erreichbar. Supermärkte und Einkaufsmöglichkeiten sind ebenfalls in der Nähe, sodass Sie Ihre Besorgungen schnell und unkompliziert erledigen können.</p>\r\n\r\n<p>Erleben Sie die perfekte Symbiose aus modernem Wohnkomfort und naturnaher Lage in Alland. Dieses Haus ist nicht nur ein Ort zum Leben, sondern ein Ort, an dem Erinnerungen geschaffen werden. Lassen Sie sich von diesem einzigartigen Angebot überzeugen und vereinbaren Sie noch heute einen Besichtigungstermin. Ihr neues Zuhause wartet auf Sie!</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1,
      class: 4,
      additionalProperties: {},
    },
    heating_demand: {
      value: 3,
      class: 3,
      additionalProperties: {},
    },
    valid_until: '2030-12-12T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 8,
          label: 'Steinboden',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 116,
          label: 'Granit',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 17,
          label: 'Fernwärme',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 18,
          label: 'Fußbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Küche',
      items: [
        {
          id: 23,
          label: 'Wohnküche / offene Küche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 33,
          label: 'Bad mit Fenster',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 34,
          label: 'Badewanne',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 35,
          label: 'Dusche',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 930,
          label: 'Bad mit WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 46,
          label: 'Parkplatz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Belüftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 93,
          label: 'Luftwärmepumpe',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Balkon',
      items: [
        {
          id: 106,
          label: 'Südwestbalkon / -terrasse',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'WCs',
      items: [
        {
          id: 162,
          label: 'Toilette',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 167,
          label: 'Gäste-WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Dachform',
      items: [
        {
          id: 173,
          label: 'Satteldach',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 670,
          label: 'Doppel- / Mehrfachverglasung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Extras',
      items: [
        {
          id: 679,
          label: 'Grillstelle',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 688,
          label: 'Weinkeller',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 691,
          label: 'Whirlpool',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 933,
          label: 'Fitnessraum',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 969,
          label: 'Grünblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    259044556:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose\\u0022, \\u00222023_07_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 650.000,00\\u00A0\\u20AC","Created_at":"2024-09-25T14:51:13+02:00","Offertext":"\\u003Ch3\\u003EHier finden Sie Informationen inkl. umfangreichem Expos\\u00E9 zu Ihrem Immobilienangebot:\\u003C/h3\\u003E\\u003Cp\\u003EViele unserer Immobilien k\\u00F6nnen Sie online mittels \\u003Cstrong\\u003E360\\u00B0 Rundgang\\u003C/strong\\u003E besichtigen! Klicken Sie dazu einfach auf das entsprechende 360\\u00B0 Symbol unten im Bild.\\u003Cbr /\\u003E\\nAuch auf unserer Webseite www.sreal.at\\u00A0finden Sie viele Objekte mit Online-Rundgang!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/25182919/35316517/7d3f8c9e62fa015e7b48706cdd6d50f9d83b5886/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"76hEgISEPrcHPtJJq0li6X.pdf","Url":"https://api.justimmo.at/v1/file/76hEgISEPrcHPtJJq0li6X.pdf","Original_filename":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose.pdf","Title":"960-69434_-_Wohnung_-_Kauf_-_2265_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2024-09-25T14:51:15+02:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":8165723,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"3NTWwcryptUvPi3NB0ygqx.pdf","Url":"https://storage.justimmo.at/file/3NTWwcryptUvPi3NB0ygqx.pdf","Original_filename":"2023_07_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2023-07-06T12:49:10+02:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":96487,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    275947381:
      '{"ActivityTypeId":12,"ActivityTypeName":"Objektstatus\\u00E4nderung: reserviert","Comment":"von: 16.01.2025, bis: 23.01.2025","Created_at":"2025-01-16T14:47:46+01:00","Offertext":null,"Files":[],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: 'none',
    dual_brokerage: false,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: {
      id: [],
      name: [],
    },
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
    ImmoLiveHighestBid: 0,
  },
};

export const interessentimmo4_parsed = parseImmo(interessentimmo4);

export const interessentimmo4_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 189,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 807,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 8392,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 146,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 146,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 229,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 251,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 21,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 493,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 3828,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 3832,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 297,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 5887,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 53,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 190,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};
